export const IS_LOCAL = process.env.REACT_APP_ENV.includes('local')
export const WEB_URL = window.location.origin + ((!IS_LOCAL && process.env.PUBLIC_URL) || '')
export const DEFAULT_AGOL_PORTAL_URL = 'https://www.arcgis.com'
